import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.function.name.js";
import _isEmpty from "lodash/isEmpty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment } from 'react';
import { CONTEXT } from './constants';
/*
 * A Higher-Order Component that is used to wrap a Component to augment it with a script tag
 * containing JSON-LD schema.
 *
 * @param {Object|function} mapping An object or a function returning an object that represents
 *                                  your JSON-LD schema.
 */

var withJsonLd = function withJsonLd(mapping) {
  return function (WrappedComponent) {
    var WithJsonLd = function WithJsonLd(props) {
      var mappedJsonLd = typeof mapping === 'function' ? mapping(props) : mapping;

      if (!mappedJsonLd || _isEmpty(mappedJsonLd)) {
        return /*#__PURE__*/React.createElement(WrappedComponent, props);
      }

      var jsonLd = _objectSpread(_objectSpread({}, CONTEXT), mappedJsonLd);

      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(WrappedComponent, props), /*#__PURE__*/React.createElement("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(jsonLd)
        }
      }));
    };

    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithJsonLd.displayName = "WithJsonLd(".concat(displayName, ")");
    return WithJsonLd;
  };
};

export default withJsonLd;